import type { MouseEvent, ReactNode } from "react";
import { EllipsisIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface RowAction {
  label: ReactNode;
  onSelect: () => void;
  disabled?: boolean;
  /** Stops or removes something. */
  danger?: boolean;
}

// A click inside the menu must not also be a click on the row under it: the
// menu is portalled, but React still bubbles its events up the component
// tree, into the row's own onClick.
function stop(event: MouseEvent) {
  event.stopPropagation();
}

/** The "…" at the end of a row, for the actions that are not the row's
 * main one. */
export function RowActions({ actions, label = "Műveletek" }: { actions: RowAction[]; label?: string }) {
  if (actions.length === 0) return null;
  return (
    <div className="flex justify-end" onClick={stop}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon-sm" aria-label={label}>
            <EllipsisIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" onClick={stop}>
          {actions.map((action, index) => (
            <DropdownMenuItem
              key={index}
              disabled={action.disabled}
              variant={action.danger ? "destructive" : "default"}
              onSelect={action.onSelect}
            >
              {action.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
